/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

/**
 * The standard "add a row / item" control - a centred `add_circle` icon button shown under simple
 * lists (attachments, actions, child requests, ...). Carries `data-grid-new` so the Playwright
 * helpers that add grid rows locate it the same way they do inside a real grid. When more than one
 * such button can be on a page at once, set `newId` so each gets a distinct `data-grid-new` value.
 */
@Component({
    selector: 'app-add-item-button',
    imports: [MatButtonModule, MatIconModule, MatTooltipModule],
    template: `
        <div class="add-item">
            <button mat-icon-button [attr.data-grid-new]="newId || ''"
                    [disabled]="disabled" [matTooltip]="tip" (click)="add.emit()">
                <mat-icon color="primary">add_circle</mat-icon>
            </button>
        </div>
    `,
    styles: [`
        .add-item {
            margin-top: 12px;
            text-align: center;
        }
        .add-item button {
            padding: 0;
        }
        .add-item mat-icon {
            height: 28px;
            width: 28px;
            font-size: 28px;
        }
    `]
})
export class AddItemButtonComponent {
    @Input() tip = 'Add';
    @Input() disabled = false;
    /** Distinct value for data-grid-new when several add buttons share a page (test hook). */
    @Input() newId = '';
    @Output() add = new EventEmitter<void>();
}
